import React from 'react';
import { Divider as MuiDivider } from '@mui/material';
import { BoxProps } from '../Box';
import { extractPounceProps, mapPouncePropsToSx } from '../../utils';

export interface DividerProps extends BoxProps {
  /** The direction of the divider */
  orientation?: 'horizontal' | 'vertical';
}

/**
 * Extends Box.
 *
 * A Divider is a simple component that will render a line to separate content into two sections
 */
export const Divider: React.FC<DividerProps> = ({
  orientation = 'horizontal',
  as = 'hr',
  sx,
  color,
  backgroundColor,
  borderColor,
  ...rest
}) => {
  // Divider color can be derived from various Box props.
  const dividerColor = color || backgroundColor || borderColor;
  const { pounceProps, otherProps } = extractPounceProps(rest);
  const pounceStyles = mapPouncePropsToSx(pounceProps);

  // Combine pounce-generated styles with user-provided sx
  // MUI sx prop supports object merging when both are objects
  const combinedSx = { ...pounceStyles, ...sx };

  // Only override borderColor if a color prop is explicitly provided
  const finalSx = dividerColor ? { ...combinedSx, borderColor: dividerColor } : combinedSx;

  return (
    <MuiDivider
      component={as as React.ElementType}
      aria-orientation={orientation}
      orientation={orientation}
      sx={finalSx}
      {...otherProps}
    />
  );
};
